import fetch from 'node-fetch';

import { getEnvironmentSettings } from '@pb/services';
import { TNormalisedNotification, TNotifications } from './notifications.types';
import { normaliseNotificationData } from './notifications.logic';

export async function getNotifications(): Promise<TNotifications> {
    const { propertyApi } = getEnvironmentSettings();

    const result = await fetch(
        `${propertyApi}/ActivityDashboard/GetActivityDocument`,
        {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Cache': 'no-cache',
                'X-Requested-With': 'XMLHttpRequest',
            },
            // @ts-ignore
            credentials: 'include',
        }
    );

    if (result.status >= 400) {
        throw result;
    }

    return await result.json();
}

export async function getFormattedNotifications(): Promise<
    TNormalisedNotification[]
> {
    const response = await getNotifications();

    const normalisedResponse = normaliseNotificationData(response);

    const sortedResponse = normalisedResponse.sort(function (a, b) {
        return (
            new Date(b.lastUpdated).valueOf() -
            new Date(a.lastUpdated).valueOf()
        );
    });

    return sortedResponse;
}
